import { makeStyles } from '@material-ui/core/styles';
import { motionDurationsMs, motionEaseOut } from 'core/components/theme/motion';

export default makeStyles((theme) => ({
  '@keyframes waitArtAssemble': {
    from: { opacity: 0, transform: 'translateY(10px) scale(0.97)' },
    to: { opacity: 1, transform: 'none' }
  },
  '@keyframes waitCloudDrift': {
    '0%, 100%': { transform: 'translateX(0)' },
    '50%': { transform: 'translateX(12px)' }
  },
  '@keyframes waitBirdDrift': {
    '0%, 100%': { transform: 'translate(0, 0)' },
    '50%': { transform: 'translate(-8px, -3px)' }
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(3),
    textAlign: 'center',
    boxSizing: 'border-box',
    width: 'max-content',
    maxWidth: `calc(100vw - ${theme.spacing(8)}px)`,
    padding: theme.spacing(6),
    backgroundColor: theme.colors.modal__background_primary,
    border: `1px solid ${theme.colorPalette.beige_50}`,
    borderRadius: theme.sizes.roundCorners,
    boxShadow: theme.shadows[6],
    '&[data-wait="illustrated"]': {
      position: 'fixed',
      inset: 0,
      transform: 'none',
      zIndex: theme.zIndex.modal - 1,
      width: '100%',
      maxWidth: 'none',
      backgroundColor: theme.colorPalette.beige_25,
      border: 0,
      borderRadius: 0,
      boxShadow: 'none',
      cursor: 'wait'
    }
  },
  art: {
    '--motion-duration-illustration': `${motionDurationsMs.illustration}ms`,
    '--motion-ease-out': motionEaseOut,
    width: 560,
    maxHeight: '65vh',
    maxWidth: '100%',
    height: 'auto',
    aspectRatio: '23 / 15',
    objectFit: 'contain',
    borderRadius: theme.sizes.roundCorners,
    '& .trace': { display: 'none' },
    '& .sun': { fill: theme.colorPalette.orange_50 },
    '& .cloud': {
      fill: theme.colorPalette.beige_50,
      animation: '$waitCloudDrift 17s ease-in-out infinite'
    },
    '& .bird': {
      fill: 'none',
      stroke: theme.colorPalette.green_100,
      strokeWidth: 1.5,
      strokeLinecap: 'round',
      animation: '$waitBirdDrift 23s ease-in-out infinite'
    },
    '& .paint > .piece': {
      transformBox: 'fill-box',
      transformOrigin: '50% 100%',
      // The scene assembles once; only the two small sky details keep moving.
      animation: '$waitArtAssemble var(--motion-duration-illustration) var(--motion-ease-out) both'
    },
    ...Object.fromEntries(
      [2, 3, 4, 5].map((piece) => [
        `& .paint > .piece:nth-child(${piece})`,
        { animationDelay: `${(piece - 1) * motionDurationsMs.illustrationStagger}ms` }
      ])
    ),
    '@media (prefers-reduced-motion: reduce)': { '& .piece, & .cloud, & .bird': { animation: 'none' } },
    ':root[data-input="keyboard"] & .piece, :root[data-input="keyboard"] & .cloud, :root[data-input="keyboard"] & .bird':
      { animation: 'none' }
  },
  spinner: { color: theme.colors.loading_bar },
  label: { color: theme.colors.text_primary, justifyContent: 'center' }
}));
